import { render } from "./StatsView.vue?vue&type=template&id=d8194116&scoped=true"
import script from "./StatsView.vue?vue&type=script&lang=js"
export * from "./StatsView.vue?vue&type=script&lang=js"

import "./StatsView.vue?vue&type=style&index=0&id=d8194116&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8194116"]])

export default __exports__